export interface ProgressStepsItems {
    route: string,
    displayText: string,
}
export const ProfileProgressStepsList: ProgressStepsItems[] = [
	{ route: '/profile/personal-details', displayText: 'Personal Details' },
    {
		route: '/profile/bank-details',
        displayText :'Bank Details'
    },
    {
        route :'/profile/risk-profile',
		displayText: 'Risk Profile',
    },
    {
        route :'/profile/occupation-nominee-details',
        displayText :"Occupation & Nominee Details"
    },
    {
        route :'/profile/mandates/setup-mandate',
        displayText :"Setup Bank Mandate"
    }
]
